export default __webpack_public_path__ + "static/media/logo_ceo.6fee5682.png";